import { TablePagination } from "@mui/material";
import { StyledDataGrid } from "./styled_data_grid";
import { PrincipalDocumentosLista } from "../../features/auditoria/domain/models/documentos_lista";
import { useMemo } from "react";
import { GeneratePrincipalDocColumns } from "../columns/principal";

interface PrincipaisDocGridProps {
  loading: boolean;
  rows: PrincipalDocumentosLista[];
  totalItems: number;
  page: number;
  rowsPerPage: number;
  onPageChange: (newPage: number) => void;
  onRowsPerPageChange: (newRowsPerPage: number) => void;
  onActionExportar: (IdArquivoModulo: number, NomeArquivo: string) => void;
  tableName?: string;
  height?: string;
}

export const PrincipaisDocGrid = ({
  loading,
  rows,
  totalItems,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  onActionExportar = () => null, 
  tableName = "documentos lista",
  height = "600px"
}: PrincipaisDocGridProps) => {

  const columns = useMemo(() => {
    return GeneratePrincipalDocColumns({
      onActionExportar,
    });
  }, [onActionExportar]);

  return (
    <div className="w-full flex flex-col">
      <StyledDataGrid
        tableName={tableName}
        disableColumnMenu={false}
        getRowId={(row: PrincipalDocumentosLista) => row.IdArquivoModulo}
        columns={columns}
        loading={loading}
        rows={rows}
        rowCount={totalItems}
        sx={{
          '& .status-header': {
            backgroundColor: '#AFDFD5',
            color: '#000'
          }
        }}
        pageSizeOptions={[10]}
        height={height}
        paginationMode="server"
        paginationModel={{
          page: page,
          pageSize: rowsPerPage,
        }}
      />
      
      <TablePagination
        component="div"
        count={totalItems}
        page={page - 1} 
        onPageChange={(_, p) => onPageChange(p)}
        rowsPerPageOptions={[10, 25, 50, 100]}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => onRowsPerPageChange(parseInt(e.target.value))}
      />
    </div>
  );
};

export default PrincipaisDocGrid;